export const brandConfigs = {
    'en-US': {
        brandId: 'insight',
        themeClass: 'insight-theme',
        defaultColors: {
            background: 'transparent',
            text: '#ffffff',
            btnHeader: '#6e6965'
        },
        features: {
            showColorPicker: false
        }
    },
    'es': {
        brandId: 'vpv',
        themeClass: 'vpv-branded',
        defaultColors: {
            background: '#e6e6e6',
            text: '#000000',
            btnHeader: '#6e6965'
        },
        features: {
            showColorPicker: false
        }
    }
};

export const getBrandConfig = (lang) => {
    if (lang && lang.toLowerCase().startsWith('es')) {
        return brandConfigs['es'];
    }
    return brandConfigs['en-US'];
};
